import { getCoreDataDictionaryViewReferencesAsyncSlice } from './get';

export const { requestGetCoreDataDictionaryViewReferences, resetGetCoreDataDictionaryViewReferences } =
	getCoreDataDictionaryViewReferencesAsyncSlice.asyncActionCreators;

